import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string;
  ventCapId: number;
}

export function useDeleteVentCap() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, ventCapId }: Params) =>
      del({
        url: `/api/projects/${projectId}/ventcaps/${ventCapId}`,
      }),
    onSuccess: (_, { projectId, installationId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getVentCaps(projectId, installationId),
      });
    },
  });

  const deleteVentCap = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteVentCap,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
